import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { fetchSeriesListings, seriesListingsSelector } from '../../../LandingPage/LandingPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { CarouselSection, IconCollection } from '../../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { LISTING_TYPE_SERIES } from '../../../../constants';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import { getListingEmptyCardData } from '../listingEmptyCardData';

const SeriesSection = ({ sectionName, description, currentUser }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const seriesListings = useSelector(seriesListingsSelector);

  useEffect(() => {
    dispatch(fetchSeriesListings());
  }, []);

  const showMoreSeries = () => {
    history.push(createResourceLocatorString('SeriesPage', routeConfiguration, {}));
  };

  const emptyCardData = getListingEmptyCardData({
    currentUser,
    listings: seriesListings,
    listingType: LISTING_TYPE_SERIES,
    icon: <IconCollection icon="icon-series" />,
    intl,
    defaultTitleId: 'ListingEmptyCard.seriesTitle',
    defaultTextId: 'ListingEmptyCard.seriesText',
  });

  return seriesListings?.length ? (
    <CarouselSection
      name={sectionName}
      description={description}
      items={seriesListings}
      handleAction={showMoreSeries}
      emptyCardData={emptyCardData}
    />
  ) : null;
};

export default SeriesSection;
